import { StyleSheet } from 'react-native-unistyles';

import { theme } from '@squire/ui';

// The price is pinned to the right edge of the card, above its bottom border.
const cornerBadge = {
  position: 'absolute',
  right: 0,
  bottom: theme.spacing[5],
  alignItems: 'center',
  justifyContent: 'center',
  paddingVertical: theme.spacing[3],
  paddingHorizontal: theme.spacing[5],
  borderTopLeftRadius: theme.borderRadius.m,
  borderBottomLeftRadius: theme.borderRadius.m,
} as const;

export const styles = StyleSheet.create((colors) => ({
  container: {
    borderRadius: theme.borderRadius.l,
  },

  content: ({ pressed }: { pressed: boolean }) => ({
    flex: 1,

    paddingHorizontal: theme.spacing[5],
    paddingVertical: theme.spacing[5],
    borderRadius: theme.borderRadius.m,
    overflow: 'hidden',
    borderWidth: 1.5,
    borderColor: colors.borderSecondary,
    variants: {
      state: {
        default: {
          backgroundColor: pressed ? colors.backgroundL1Alpha : 'transparent',
          borderColor: pressed
            ? colors.backgroundL1Alpha
            : colors.borderPrimary,
        },
        selected: {
          backgroundColor: colors.backgroundPrimaryInverse,
          borderColor: colors.borderPrimary,
        },
        addon: {
          backgroundColor: colors.backgroundL1,
          borderColor: colors.borderPrimary,
        },
      },
    },
  }),

  duration: {
    marginRight: theme.spacing[3],
  },

  header: {
    alignItems: 'flex-start',
  },
  headerInfo: {
    flex: 1,
  },

  // Reserves the room the pinned price badge takes below the content.
  priceSpacer: {
    height: theme.spacing[9],
  },
  price: {
    ...cornerBadge,
    width: 'auto',

    variants: {
      state: {
        default: {
          backgroundColor: colors.backgroundL1,
        },
        selected: {
          backgroundColor: colors.backgroundL1Inverse,
        },
        addon: {
          backgroundColor: colors.backgroundL1,
        },
      },
    },
  },

  addonBadge: {
    alignSelf: 'flex-start',
    paddingHorizontal: theme.spacing[2],
    paddingVertical: theme.spacing[1],
    borderRadius: theme.borderRadius.xs,
    backgroundColor: colors.backgroundBrandSubtle,
    marginRight: theme.spacing[3],
  },

  priceBadgePrimary: {
    ...cornerBadge,
    backgroundColor: colors.backgroundL2Inverse,
  },
  priceBadgeAddon: {
    ...cornerBadge,
    backgroundColor: colors.backgroundL1Alpha,
  },
  removeButtonPrimary: {
    width: 32,
    height: 32,
    borderRadius: theme.borderRadius.full,
    borderWidth: 1,
    borderColor: colors.borderPrimary,
    alignItems: 'center',
    justifyContent: 'center',
  },
  removeButtonAddon: {
    width: 32,
    height: 32,
    borderRadius: theme.borderRadius.full,
    borderWidth: 1,
    borderColor: colors.backgroundPrimaryInverse,
    alignItems: 'center',
    justifyContent: 'center',
  },
  minusLinePrimary: {
    width: 11,
    height: 2,
    backgroundColor: colors.textPrimaryInverse,
    borderRadius: theme.borderRadius.full,
  },
  minusLineAddon: {
    width: 11,
    height: 2,
    backgroundColor: colors.backgroundPrimaryInverse,
    borderRadius: theme.borderRadius.full,
  },
}));
